import { Logo } from '../components/Logo';
import { Billing } from './lessee/Billing';

// Public preview of the lessee Billing view with sample data (no auth/data).
export function BillingPreview() {
  return (
    <div className="min-h-screen bg-sky-50/40">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <Logo className="h-7" />
          <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-800">
            Billing preview — sample data
          </span>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-4 py-8">
        <Billing preview />
      </main>
    </div>
  );
}
